import { action } from 'typesafe-actions';
import * as constants from './constants';
import * as models from '../../models';

export const createCompany = (company: models.CreateCompanyRequest) =>
    action(constants.REQUEST_CREATE_COMPANY, { company });
export const createCompanySuccess = () =>
    action(constants.REQUEST_CREATE_COMPANY_SUCCESS);
export const createCompanyFailed = () =>
    action(constants.REQUEST_CREATE_COMPANY_FAILED);

export const updateCompany = (companyId: number, company: models.Company) =>
    action(constants.REQUEST_COMPANY_UPDATE, { companyId, company }); 
export const updateCompanyFailed = () =>
    action(constants.REQUEST_COMPANY_UPDATE_FAILED);
export const updateCompanySuccess = () =>
    action(constants.REQUEST_COMPANY_UPDATE_SUCESS);
    
export const requestCompany = (companyId: number) =>
    action(constants.REQUEST_COMPANY, { companyId }); 

export const receiveCompany = (company: models.Company) => 
    action(constants.RECEIVE_COMPANY, { company }); 

export const requestCompanyCSV = (request: models.CompaniesRequest) =>
    action(constants.REQUEST_COMPANIES_CSV, { request });
export const receiveCompanyCSV = () =>
    action(constants.RECEIVE_COMPANIES_CSV);

export const requestCompanyList = (request: models.CompaniesRequest) =>
    action(constants.REQUEST_COMPANY_LIST, { request }); 

export const receiveCompanyList = (response: models.CompaniesResponse) =>
    action(constants.RECEIVE_COMPANY_LIST, { response }); 

export const requestInsCompanyList = (paging: models.Paging) =>
    action(constants.REQUEST_INSURANCE_COMPANY_LIST, { paging }); 

export const receiveInsCompanyList = (response: models.CompaniesResponse) =>
    action(constants.RECEIVE_INSURANCE_COMPANY_LIST, { response });    
    
export const requestCompanyDropdown = (request: models.CompaniesRequest) =>
    action(constants.REQUEST_COMPANY_DROPDOWN, { request }); 

export const receiveCompanyDropdown = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_COMPANY_DROPDOWN, { response }); 

// company files
export const requestCompanyFiles = (request: models.CompanyFileRequest) =>
    action(constants.REQUEST_COMPANY_FILES, { request });
export const receiveCompanyFiles = (response: models.CompanyFileResponse) =>
    action(constants.RECEIVE_COMPANY_FILES, { response });

export const uploadCompanyFile = (payload: models.AddCompanyFile) =>
    action(constants.REQUEST_UPLOAD_COMPANY_FILE, { payload });
export const uploadCompanyFileSuccess = () =>
    action(constants.REQUEST_UPLOAD_COMPANY_FILE_SUCCESS);
export const uploadCompanyFileFailed = () =>
    action(constants.REQUEST_UPLOAD_COMPANY_FILE_FAILED);

export const deleteCompanyFile = (fileId: number, companyId: number) =>
    action(constants.REQUEST_DELETE_COMPANY_FILE, { fileId, companyId });
export const deleteCompanyFileSuccess = () =>
    action(constants.REQUEST_DELETE_COMPANY_FILE_SUCCESS);
export const deleteCompanyFileFailed = () =>
    action(constants.REQUEST_DELETE_COMPANY_FILE_FAILED);

// company file types
export const requestCompanyFileTypesList = (request: models.CompanyFileTypeRequest) =>
    action(constants.REQUEST_COMPANY_FILE_TYPES_LIST, { request});
export const receiveCompanyFileTypesList = (response: models.CompanyFileTypeResponse) =>
    action(constants.RECEIVE_COMPANY_FILE_TYPES_LIST, { response });

export const addCompanyFileType = (fileType: models.AddCompanyFileType) =>
    action(constants.REQUEST_ADD_COMPANY_FILE_TYPE, { fileType });
export const addCompanyFileTypeSuccess = () =>
    action(constants.REQUEST_ADD_COMPANY_FILE_TYPE_SUCCESS);
export const addCompanyFileTypeFailed = () =>
    action(constants.REQUEST_ADD_COMPANY_FILE_TYPE_FAILED);

export const updateCompanyFileType = (fileType: models.CompanyFileType) =>
    action(constants.REQUEST_COMPANY_UPDATE_FILE_TYPE, { fileType });
export const updateCompanyFileTypeSuccess = () =>
    action(constants.REQUEST_COMPANY_UPDATE_FILE_TYPE_SUCCESS);
export const updateCompanyFileTypeFailed = () =>
    action(constants.REQUEST_COMPANY_UPDATE_FILE_TYPE_FAILED);

export const requestCompanyFileTypesDD = () =>
    action(constants.REQUEST_COMPANY_FILE_TYPES_DD);
export const receiveCompanyFileTypesDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_COMPANY_FILE_TYPES_DD, { response });

export const requestFileTypeSections = (fileTypeId: number, companyId?: number | null) => 
    action(constants.REQUEST_FILE_TYPE_SECTIONS, { fileTypeId, companyId: companyId ?? null });
export const receiveFileTypeSections = (fileTypeId: number, sections: models.DocumentSectionMeta[]) =>
    action(constants.RECEIVE_FILE_TYPE_SECTIONS, { fileTypeId, sections });

// dropdowns
export const requestAllCompaniesDD = () => 
    action(constants.REQUEST_ALL_COMPANIES_DD); 
export const receiveAllCompanyiesDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_ALL_COMPANIES_DD, { response }); 

export const requestAgentCompanyDD = () => 
    action(constants.REQUEST_AGENT_COMPANY_DD); 
export const receiveAgentCompanyDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_AGENT_COMPANY_DD, { response }); 

export const requestInsCompanyDD = () =>
    action(constants.REQUEST_INS_COMPANY_DD); 
export const receiveInsCompanyDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_INS_COMPANY_DD, { response }); 

export const requestMortgageCompanyDD = () =>
    action(constants.REQUEST_MORTGAGE_COMPANY_DD); 
export const receiveMortgageCompanyDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_MORTGAGE_COMPANY_DD, { response }); 